import WorkOrderImageUpload, {
  FullImageType,
} from "../../../components/customer-order/WorkOrderImageUpload";
import __ from "../../../utils/utils";

interface Props {
  className?: string;
  onSubmit(images: FullImageType[]): void;
  onGoBack(): void;
  defaultValues?: FullImageType[];
}

const CustomerWorkOrderImagesFormStep = (props: Props) => {
  return (
    <section className={__.classNames("", props.className)}>
      <main>
        <WorkOrderImageUpload
          uploadLabel="Gå vidare"
          defaultValues={props.defaultValues}
          onSubmit={props.onSubmit}
          onGoBack={props.onGoBack}
        />
      </main>
    </section>
  );
};

export default CustomerWorkOrderImagesFormStep;
